var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isHtml)?_c('p',{staticClass:"font-body-s"},[_vm._t("default")],2):_c('p',{staticClass:"font-body-s",domProps:{"innerHTML":_vm._s(_vm.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }